import { SignalBase } from "./SignalBase";
import { SignalConnection } from "./SignalConnection";
//
// Flambe - Rapid game development
// https://github.com/aduros/flambe/blob/master/LICENSE.txt

/**
 * An alias for Signal0 listeners.
 */
interface Listener0 {
  (): void;
}

/**
 * A zero-argument signal. See Signal1 and Signal2 for different arities.
 */
export class Signal0 extends SignalBase {
  /**
   * @param listener An optional listener to immediately connect to the signal.
   */
  constructor(listener?: Listener0) {
    super(listener);
  }

  /**
   * Connects a listener to this signal.
   * @param prioritize True if this listener should fire before others.
   * @returns A SignalConnection, that can be disposed to remove the listener.
   */
  public connect(
    listener: Listener0,
    prioritize: boolean = false
  ): SignalConnection {
    return this.connectImpl(listener, prioritize);
  }

  /**
   * Emit the signal, notifying each connected listener.
   */
  public emit() {
    if (this.dispatching()) {
      this.defer(() => {
        this.emitImpl();
      });
    } else {
      this.emitImpl();
    }
  }

  private emitImpl() {
    let head = this.willEmit();
    let p = head;
    while (p != null) {
      p._listener();
      if (!p.stayInList) {
        p.dispose();
      }
      p = p._next as SignalConnection;
    }
    this.didEmit(head);
  }
}
